<template>
  <div class="user-account">
    <UserAccountForm v-if="account.id || (!account.id && !account.username)" />

    <UserOrganizations
      v-if="(account.id || account.username) && !account.isAdmin()"
      style="margin-top: 50px"
      :max-organizations="maxOrganizations"
      @organization:added="organizationAdded"
    />

    <!-- <UserPermissions v-if="account.id" /> -->

    <div v-if="!account.id && account.username" class="row">
      <div class="col-md-12 text-right">
        <btn
          :disabled="!hasOrganizations"
          title="Koniec"
          disabled-title="Koniec"
          variant="primary"
          @click="finishCreateAccount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UserAccountForm from "./UserAccountForm";
import UserOrganizations from "./UserOrganizations";
import UserPermissions from "./UserPermissions";

import ModalConfirm from "@/mixins/ModalConfirm";

import { mapState, mapGetters } from "vuex";

// import { UserModel, OrganizationModel } from "@/model/";

export default {
  name: "UserAccount",
  components: {
    UserAccountForm,
    UserOrganizations,
    UserPermissions
  },
  mixins: [ModalConfirm],
  data() {
    return {
      maxOrganizations: 1
    };
  },
  computed: {
    ...mapState("Account", ["account"]),
    ...mapGetters("Account", { organizations: "getUserOrganizations" }),
    hasOrganizations() {
      return !!this.organizations.length;
    },
    userId() {
      return this.$route.params.id > 0
        ? this.$route.params.id
        : this.account.id;
    },
    isNew() {
      return !this.userId;
    }
  },
  created() {
    this.$store.dispatch("Account/get", this.userId);
  },
  methods: {
    organizationAdded() {
      this.okDialog(
        "Członkostwo w organizacji musi zostać zatwierdzone przez Compliance Officera, dopiero wtedy będzie można zgłaszać wydarzenia w Systemie."
      ).then(() => {
        if (this.organizations.length >= this.maxOrganizations && this.isNew) {
          this.finishCreateAccount();
        }
      });
    },
    finishCreateAccount() {
      this.$store.dispatch("User/finishCreateAccount");
      this.okDialog(
        "Konto zostało utworzone. Konto i przypisane do niego organizacje muszą zostać aktywowane przez Compliance Officera."
      ).then(() => {
        this.$router.push("login");
      });
    }
  }
};
</script>
